import { render, staticRenderFns } from "./jianyan.vue?vue&type=template&id=1f277508&scoped=true&"
import script from "./jianyan.vue?vue&type=script&lang=ts&"
export * from "./jianyan.vue?vue&type=script&lang=ts&"
import style0 from "./jianyan.vue?vue&type=style&index=0&id=1f277508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f277508",
  null
  
)

export default component.exports